const isProduction = process.env.NODE_ENV === 'production'

// import 'focus-visible'

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector<HTMLDialogElement>('.my-pages-migration-modal')) {
    import('./components/my-pages-migration-modal').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.main-navigation')) {
    import('components/main-navigation').then((module) => module.default.init())
  }

  if (
    document.querySelector<HTMLInputElement>('#search') ||
    document.querySelector<HTMLButtonElement>('.button--reset')
  ) {
    import('components/focus-search').then((module) => module.default.init())
  }

  if (
    document.querySelector<HTMLButtonElement>('.button--toggle') ||
    document.querySelector<HTMLButtonElement>('.button--toggle--off')
  ) {
    import('./components/toggle-buttons').then((module) => module.default.init())
  }

  if (
    document.querySelector<HTMLButtonElement>('.button--toggle--icon') ||
    document.querySelector<HTMLButtonElement>('.button--toggle--off--icon')
  ) {
    import('./components/toggle-buttons-amount').then((module) => module.default.init())
  }

  if (
    document.querySelector<HTMLElement>('.search-overlay') ||
    document.querySelector<HTMLElement>('.search-overlay__searchItems') ||
    document.querySelector<HTMLElement>('#search')
  ) {
    import('./search/search').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLButtonElement>('.healthTestBanner')) {
    import('./components/healthtest-banner').then((module) => module.default.init())
  }

  if (document.querySelector('.healthTestForParentsBanner__image')) {
    import('./components/newHealthTestBanner').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLButtonElement>('.healthWorldBanner')) {
    import('./components/healthworld-banner').then((module) => module.default.init())
  }

  if (document.querySelector('.article')) {
    import('./components/wordTranslation').then((module) => module.default.init())
  }

  if (document.querySelectorAll('.wordTranslation').length) {
    import('./components/tooltip').then((module) => module.default.init())
  }

  if (document.querySelector('.healthtest-section__step--active')) {
    import('./components/newHealthTestInputs').then((module) => {
      module.default.init()
      import('./components/newHealthTestScores').then((scoreModule) => scoreModule.default.init())
    })
  }

  const hasNewHealthTestAnalytics = Boolean(document.querySelector('[data-healthtest-analytics]'))
  const hasNewHealthTestSummary =
    document.querySelector('.healthtest-section-summary') ||
    document.querySelector('[data-healthtest-start], [data-healthtest-restart]')

  if (hasNewHealthTestSummary) {
    import('./components/newHealthTestSectionSummary').then((module) => {
      module.default.init()
      if (hasNewHealthTestAnalytics) {
        import('./components/newHealthTestAnalytics').then((analyticsModule) => analyticsModule.default.init())
      }
    })
  } else if (hasNewHealthTestAnalytics) {
    import('./components/newHealthTestAnalytics').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLButtonElement>('.mobile__infobutton')) {
    import('./components/map-navigation').then((module) => module.default.init())
  }

  if (
    document.querySelector<HTMLButtonElement>('.sugarBanner') ||
    document.querySelector<HTMLButtonElement>('.sugarBanner__background') ||
    document.querySelector<HTMLButtonElement>('.sugarBanner__image')
  ) {
    import('./components/sugar-banner').then((module) => module.default.init())
  }

  if (document.querySelector('[data-id=illustration]')) {
    import('./components/illustration').then((module) => module.default.init())
  }

  //FIX ME
  import('./components/table-wrapper').then((module) => module.default.init())

  if (document.querySelector('.accordion__item')) {
    import('./components/accordion').then((module) => module.default.init())
  }

  if (document.querySelector('.article')) {
    import('./components/helperQuestion').then((module) => module.default.init())
  }

  if (
    document.querySelector('.article__heading1') ||
    document.querySelector('.article__navItems') ||
    document.querySelector('.article__chapterWrapper')
  ) {
    import('./components/article-nav').then((module) => module.default.init())
  }

  if (document.querySelector('.popover')) {
    import('./components/popover').then((module) => module.default.init())
  }

  if (document.querySelector('.simple-banner')) {
    import('./components/simple-banner').then((module) => module.default.init())
  }

  if (document.querySelector('.tabcontrol')) {
    import('./components/tab-control').then((module) => module.default.init())
  }

  if (document.querySelector('.video-overlay')) {
    import('./components/video').then((module) => module.default.init())
  }

  if (document.querySelector('.body-mass-calculator') || document.querySelector('.blood-pressure__page')) {
    import('./components/rulerSlider').then((module) => module.default.init())
  }

  if (document.querySelector('.blood-pressure__page')) {
    import('./components/BloodPressureCalculator').then((module) => module.default.init())
  }

  if (document.querySelector('.body-mass-calculator')) {
    import('./components/BodyMassCalculator').then((module) => module.default.init())
  }

  if (document.querySelector('.map-container')) {
    import('./components/map').then((module) => module.default.init())
  }

  if (document.querySelector('.open-livechat')) {
    import('./components/livechat').then((module) => module.default.init())
  }

  if (document.querySelector('.main--sykurmagn')) {
    import('./components/Sykurmagn/sugarCubes').then((module) => module.default.init())
    import('./components/Sykurmagn/sugarNavigation').then((module) => module.default.init())
    import('./components/Sykurmagn/sugarRedirects').then((module) => module.default.init())
    import('./components/Sykurmagn/comparison').then((module) => module.default.init())
    import('./components/Sykurmagn/tabsMobile').then((module) => module.default.init())
    import('./components/Sykurmagn/sortProductsBy').then((module) => module.default.init())
    import('./components/Sykurmagn/tags').then((module) => module.default.init())
    import('./components/Sykurmagn/types').then((module) => module.default.init())
    import('./components/Sykurmagn/sortByAmount').then((module) => module.default.init())
  }

  if (document.querySelector('.navHT')) {
    import('./components/Hreyfitorg/ajax.js').then((module) => module.default.init())
    import('./components/Hreyfitorg/overview.js').then((module) => module.default.init())
    import('./components/Hreyfitorg/register.js').then((module) => module.default.init())
    import('./components/Hreyfitorg/sliders.js').then((module) => module.default.init())
  }

  if (document.querySelector('.fagfolk')) {
    import('./components/fagfolk').then((module) => module.default.init())
    import('./components/Fagfolk/ajax').then((module) => module.default.init())
  }

  import('./components/cookiehub').then((module) => module.default.init())

  import('./libs/hyphen').then((module) => module.default.init())

  import('libs/clickoutside').then(async (module) => {
    return module.default(() => {})
  })

  if (!isProduction) {
    if (document.querySelector<HTMLElement>('.overlay-grid')) {
      import('utility/overlayGrid').then((module) => module.default.init())
    }
  }

  setTimeout(() => {
    document.querySelector('.body')?.classList.remove('preload')
  }, 300)
})
